import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Crown = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M27 8C26.725 8 26.475 8.113 26.288 8.287L21.263 13.312L16.888 4.55C16.713 4.212 16.376 4 15.988 4C15.6 4 15.263 4.213 15.088 4.55L10.713 13.312L5.713 8.287C5.525 8.112 5.275 8 5 8C4.45 8 4 8.45 4 9C4 20.137 7.963 27.2 8.138 27.5C8.313 27.813 8.65 28 9.001 28H23.001C23.364 28 23.689 27.812 23.864 27.5C24.027 27.2 28.001 20.137 28.001 9C28.001 8.45 27.551 8 27.001 8H27ZM24.063 21.75C23.4 23.813 22.738 25.275 22.388 26H9.601C9.251 25.3 8.601 23.863 7.951 21.825C7.201 19.475 6.326 15.9 6.063 11.487L10.288 15.712C10.463 15.887 10.713 15.999 11.001 15.999C11.388 15.999 11.726 15.774 11.888 15.449L16 7.236L20.113 15.449C20.276 15.774 20.613 15.999 21 15.999C21.275 15.999 21.525 15.886 21.712 15.712L25.937 11.487C25.675 15.862 24.812 19.412 24.062 21.75H24.063Z" />
		<path d="M20 20C20 19.725 19.887 19.475 19.712 19.288L16.712 16.288C16.537 16.113 16.287 16 15.999 16C15.711 16 15.474 16.113 15.286 16.288L12.286 19.288C12.111 19.463 11.999 19.713 11.999 20C11.999 20.287 12.112 20.525 12.286 20.712L15.286 23.712C15.461 23.887 15.711 24 15.999 24C16.287 24 16.524 23.887 16.712 23.712L19.712 20.712C19.887 20.524 20 20.274 20 20ZM16 21.587L14.412 20L16 18.413L17.587 20L15.999 21.587H16Z" />
	</svg>
);

export default Crown;
